export class EmailList {

  id: number;
  name: string;
  file: number;
  description: string;
  organisation: string;
  contact: string;
  created: string;
  updated: string;
  deleted: string;
  state: string;
  owner: string;
  summary: any;

  /*

  Example of email_list payload
  {
    "id": 1,
    "name": "email_list.txt",
    "file": 2,
    "description": null,
    "organisation": null,
    "contact": null,
    "created": "2017-09-26T13:58:56.050303Z",
    "updated": "2017-09-26T13:58:56.050346Z",
    "deleted": null,
    "state": "PROCESSING",
    "owner": "http://127.0.0.1:8000/api/v1/users/1/"
  }

  */

  toJSON(): Object {
    // create an instance of the EmailList class
    let email_list = Object.create(EmailList.prototype);
    // copy all the fields from the json object
    email_list.file = this.file;
    email_list.name = this.name;

    return email_list;
  }


  static fromJSON(email_list_json: any): EmailList {

    // create an instance of the SurveyLink class
    let email_list = Object.create(EmailList.prototype);
    // copy all the fields from the json object
    let obj = Object.assign(email_list, email_list_json, {
      // fixme this conversion block may even be not used!
      // convert fields that need converting
      //created: new Date(survey_link_json.created),
      //activated: new Date(survey_link_json.activated),
      //deactivated: new Date(survey_link_json.deactivated),
      //deleted: new Date(survey_link_json.deleted),

    });
    return email_list;

  }
}

